import type { paths } from "@whilecat/generated/openapi/metric.js";
import { getClient } from "./client-utils.ts";

const client = getClient<paths>();

export enum MetricType {
    JAVA_TASK_SOLVE_ATTEMPT = "JAVA_TASK_SOLVE_ATTEMPT",
    VM_STARTUP_TIME = "VM_STARTUP_TIME",
}

export async function saveMetric(type: MetricType, payload: any) {
    return await client.POST("/metric", {
        body: { type, payload },
    });
}

export async function saveReplay(
    events: any[],
    replayId: string,
    startedAt: Date,
    sequenceNumber: number,
    endedAt?: Date,
) {
    return await client.POST("/replays", {
        body: {
            events: JSON.stringify(events),
            replayId,
            startedAt: startedAt.toISOString(),
            endedAt: endedAt?.toISOString() || null,
            sequenceNumber,
        },
    });
}

export async function getReplays(limit?: number, userId?: number) {
    const query: { userId?: number; limit?: number } = {};
    if (userId !== undefined) query.userId = userId;
    if (limit !== undefined) query.limit = limit;

    const { data } = await client.GET("/replays", { params: { query } });
    return data;
}
